export default __webpack_public_path__ + "static/media/logoblue.849067e5.svg";